export const downloadFileFromBlob = (response, filename = 'download') => {
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were

    window.navigator.msSaveBlob(response, filename)
  } else {
    const blobURL = window.URL.createObjectURL(response)
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', filename)

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }
    document.body.appendChild(tempLink)
    tempLink.click()
    // flow-disable-next-line
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobURL)
  }
}

export const formatBytes = (bytes, decimals) => {
  if (bytes === 0 || !bytes) return '0 B'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / k ** i).toFixed(decimals))} ${sizes[i]}`
}
